import angular from 'angular';
import constants from 'app/constants';
import directive from './recovery-point-objectives.directive';

// Validation
import backupRestorationTimeMessagesTpl from './messages/backup-restoration-time.messages.html';


export default angular.module('app.components.advisory.bcp.impactAnalysis.recoveryPointObjectives', [
  constants,
])
  .directive('bcpRecoveryPointObjectives', directive)
  .controller('RecoveryPointObjectivesController', () => { /* here to provide controllerAs vm */ })
  .run(($templateCache) => {
    $templateCache.put('backup-restoration-time.messages.html', backupRestorationTimeMessagesTpl);
  })
  .name;

console.log('app.components.advisory.bcp.impactAnalysis.recoveryPointObjectives created');
